<template>
  <div class="app-container">
    <el-card class="box-card mt10">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="推送状态：">
            <el-select v-model="query.isSuccess" placeholder="请选择" clearable size="small">
              <el-option label="推送成功" :value="1"></el-option>
              <el-option label="推送失败" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-table v-loading="listLoading" :data="list " @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="客户名称" prop="customerName" align="center" fixed />
        <el-table-column label="客户编码" prop="customerCode" align="center" />
        <el-table-column label="旧城市公司" prop="oldCityCompanyName" align="center" />
        <el-table-column label="新城市公司" prop="newCityCompanyName" align="center" />
        <el-table-column label="零售价" prop="customerChangeCityCompanyPO.xiaoduMoney" align="center" />
        <el-table-column label="余额" prop="customerChangeCityCompanyPO.balance" align="center" />
        <el-table-column label="学费" prop="customerChangeCityCompanyPO.tuition" align="center" />
        <el-table-column label="积分" prop="customerChangeCityCompanyPO.integral" align="center" />>
        <el-table-column label="创建时间" prop="customerChangeCityCompanyPO.createdTime" align="center" />>
        <!-- <el-table-column label="推送状态" align="center" width="150">
          <template slot-scope="{row}">
            <el-tag type="" effect="dark" v-if="row.isOk" size="mini">推送成功</el-tag>
            <el-tag type="danger" effect="dark" v-else size="mini">推送失败</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
            <el-button type="text" @click="handlePush(row)">推送</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <order-show ref="orderShow" @created="doQueryList({})" />
  </div>
</template>

<script>
import orderShow from './show'
import sysExternalSendLogApi from '@/api/sys/sysExternalSendLog'
import Pagination from '@/components/Pagination'
import homeStatisticsApi from '@/api/home'
import { Subtr, formatDateStr } from '@/utils/index'
import sysToolsApi from '@/api/sys/tools'
export default {
  components: {
    Pagination,
    orderShow
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      exceptionObj: {}
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        // canLookGoodsPrice: 1,
        // canStudyCourse: 1
      }
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query }
      this.listLoading = true
      return sysExternalSendLogApi.getChangeCityCompany(query).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    parsePayRequest(str) {
      const pairs = str.split(', ');
      const result = {};
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        // 处理 miniprogramPayInfo_VSP 字段，它是一个 JSON 字符串
        if (key === "miniprogramPayInfo_VSP") {
          try {
            result[key] = JSON.parse(value);
          } catch (error) {
            result[key] = value;
          }
        } else {
          result[key] = value;
        }
      });
      return result;
    },
    // 推送
    handlePush(row) {
      sysToolsApi.sendAuxToYongYouById({ type: row.type, id: row.id, type2: 3 }).then(res => {
        let data = res.data
        if (data.state === 1) {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        } else {
          this.$common.showMsg('error', data.returnParameter)
        }
      })
    },
    // 删除
    handleDel(row) {

    },
    /**
     * 打开详情表单
     */
    handleShow(row) {
      this.$refs.orderShow.handleUpdate(row)
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-button--success.is-plain:focus,
.el-button--success.is-plain:hover {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}
::v-deep .el-divider--horizontal {
  margin-top: 0;
}
</style>
